import { ActionTree, GetterTree, MutationTree, Module } from 'vuex';
import { getSharedApolloClient } from '@/lib/apollo_setup';
import { SENDBIRD_UNREAD_MESSAGE_QUERY } from '@/graphql/messages/queries';

export interface MessagesState {
  unreadCount: number;
  pollingInterval: number | null;
}

const initialState: MessagesState = {
  unreadCount: 0,
  pollingInterval: null,
};

const getters: GetterTree<MessagesState, any> = {
  unreadCount: (state): number => state.unreadCount,
};

const mutations: MutationTree<MessagesState> = {
  setUnreadCount(state, count: number) {
    state.unreadCount = count;
  },
  setPollingInterval(state, interval: number | null) {
    state.pollingInterval = interval;
  },
};

const actions: ActionTree<MessagesState, any> = {
  async fetchUnreadCount({ commit }) {
    try {
      const result = await getSharedApolloClient().query({
        query: SENDBIRD_UNREAD_MESSAGE_QUERY,
        fetchPolicy: 'network-only',
      });
      commit('setUnreadCount', result.data.unreadMessageCount || 0);
    } catch (error) {
      console.error('Error fetching unread message count:', error); // eslint-disable-line no-console
    }
  },

  startPolling({ dispatch, commit, state }, intervalMs = 60000) {
    if (state.pollingInterval) return;

    dispatch('fetchUnreadCount');
    const interval = window.setInterval(() => {
      dispatch('fetchUnreadCount');
    }, intervalMs);
    commit('setPollingInterval', interval);
  },

  stopPolling({ commit, state }) {
    if (state.pollingInterval) {
      clearInterval(state.pollingInterval);
      commit('setPollingInterval', null);
    }
  },
};

const messagesModule: Module<MessagesState, any> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default messagesModule;
